import React from 'react';
import Overview from '../components/OverviewComponent/Overview';

function OverviewPage() {
  return (
    <div>
      <Overview />
    </div>
  );
}

export default OverviewPage;
